module.exports = __webpack_public_path__ + "img/taro-leaf-350x184.72f45792.jpg";